const CLUB_IMAGE_LIBRARY = {
  hiking: "/assets/clubs/hiking.png",
  running: "/assets/clubs/running.png",
  cycling: "/assets/clubs/cycling.png",
  yoga: "/assets/clubs/yoga.png",
  fitness: "/assets/clubs/fitness-studio.png",
};

export const CLUB_DISCOVER_IMAGES = [
  CLUB_IMAGE_LIBRARY.hiking,
  CLUB_IMAGE_LIBRARY.fitness,
  CLUB_IMAGE_LIBRARY.running,
  CLUB_IMAGE_LIBRARY.cycling,
  CLUB_IMAGE_LIBRARY.yoga,
];

const NAMED_CLUB_IMAGE_MATCHERS = [
  { test: /hiking/i, src: CLUB_IMAGE_LIBRARY.hiking },
  { test: /running|jogging/i, src: CLUB_IMAGE_LIBRARY.running },
  { test: /cycling|bike|biking/i, src: CLUB_IMAGE_LIBRARY.cycling },
  { test: /yoga|stretch/i, src: CLUB_IMAGE_LIBRARY.yoga },
  { test: /fitness|gym|training/i, src: CLUB_IMAGE_LIBRARY.fitness },
];

export function resolveClubImageSrc(clubOrName, fallbackIndex = 0) {
  const club = clubOrName && typeof clubOrName === "object" ? clubOrName : null;
  const directSrc = String(club?.hero_image_url || "").trim();
  if (directSrc) {
    return directSrc;
  }

  const name = String(club?.name || clubOrName || "").trim();
  const matched = NAMED_CLUB_IMAGE_MATCHERS.find((item) => item.test.test(name));
  if (matched?.src) {
    return matched.src;
  }

  return CLUB_DISCOVER_IMAGES[fallbackIndex % CLUB_DISCOVER_IMAGES.length];
}

export function resolveClubCardImageSrc(clubOrName, fallbackIndex = 0) {
  const club = clubOrName && typeof clubOrName === "object" ? clubOrName : null;
  const thumbnailSrc = String(club?.hero_thumbnail_url || "").trim();
  return thumbnailSrc || resolveClubImageSrc(clubOrName, fallbackIndex);
}

export function resolveClubCoverImageSrc(clubOrName, fallbackIndex = 0) {
  const club = clubOrName && typeof clubOrName === "object" ? clubOrName : null;
  const directSrc = String(club?.hero_image_url || "").trim();
  if (directSrc) {
    return directSrc;
  }

  return resolveClubImageSrc(clubOrName, fallbackIndex);
}
